var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import WithTooltip from "./WithTooltip";
import { caretWidth } from "../tooltip/Tooltip.style";
import Flex from "../box/Flex";
import Icon from "../icons/Icon";
export const caretOffset = 16;
export const iconWidth = 16; //1rem
export const tooltipSkidding = -(caretOffset + caretWidth / 2) + iconWidth / 2;
export const tooltipDistance = 8;
export const tooltipOffset = [tooltipSkidding, tooltipDistance];
export const ariaLabel = "more info in the tooltip";
const StyledIcon = styled(Icon).withConfig({ displayName: "StyledIcon_APC-7311-productShell", componentId: "sc-1fs2hoi" })({
    "&&": {
        height: "1rem",
        width: "1rem",
    },
});
const InfoIconTooltip = (_a) => {
    var { children, offset } = _a, rest = __rest(_a, ["children", "offset"]);
    if (!children) {
        return null;
    }
    return (React.createElement(WithTooltip, { tooltipContents: children, offset: offset || tooltipOffset },
        React.createElement(Flex, Object.assign({ "aria-label": ariaLabel, role: "button" }, rest),
            React.createElement(StyledIcon, { name: "infoSmall" }))));
};
export default InfoIconTooltip;
//# sourceMappingURL=InfoIconTooltip.js.map